import styled from 'styled-components';

export const StyledPlaySimpleBalanceLayout = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 4px;
  font-weight: 700;

  .balanceLayoutContainer {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
`;
